module.exports = __webpack_public_path__ + "static/media/Fenty-Puma_thumb.619aae35.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/sneakers/Fenty-Puma_thumb.png
// module id = 302
// module chunks = 0